export default __webpack_public_path__ + "static/media/3424.7cd87e51.png";